export const testimonials = [
  {
    title: "Articles",
    stars: 5,
    text: "Great experience with Jovan and the team. Worked quickly and independently. Good communications and time management."
  },
  
  {
    title: "Expert Poker/Casino Content writer",
    stars: 5,
    text: "Worked on various gambling subject for us. Great team of content writers. Highly recommended."
  },
  
  {
    title: "Health & Wellness Content Writer",
    stars: 5,
    text: "Loved working with Jovan and his team. It has been a great experience. Thanks for amazing work."
  },
  
  {
    title: "Write Articles and Blogs",
    stars: 5,
    text: "Great to work with Jovan and the team. Good standard of writing and can tackle various tasks. Always keeps to tight deadlines"
  },
  
  {
    title: "Experienced and Creative Health/Nutrition Writer Needed - Long Term Project",
    stars: 5,
    text: "Jovan and his writers are top notch. I highly recommend them for your writing tasks. Thank you!"
  },
  
  {
    title: "Content Writer",
    stars: 5,
    text: "Great writing team - on brief and on deadline. Will hire them again in the future."
  },
  
  {
    title: "Content Writer with SEO expertise",
    stars: 4,
    text: "Always on schedule, always follows the content brief. I would recommend to anyone needing a lot of content written. I will definitely hire again."
  },
  
  {
    title: "Content/Blog Writer for Podcasting Company",
    stars: 5,
    text: "Jovan was very professional and orchestrated our writing contract efficiently and with a high level of organization. He is very familiar with SEO writing strategies and this showed in his work. The writing was informative and detailed. It was great for our needs."
  },
  
  {
    title: "Health and Fitness Writers - PT & Nutritionists Preferred",
    stars: 5,
    text: "Jovan and his team did an excellent job at creating the exact type of content we were looking for. He's easy to work with and I look forward to collaborating with the team on future projects."
  },
  
  {
    title: "Content Writer Needed - Article Re-write, New Content, Newsletter Writing",
    stars: 5,
    text: "Jovan & the team are amazing! They are great communicators, they adhere to deadlines & are very accommodating with time restrictions. A great hire, we are continuing  to use their services. Highly Recommended!"
  },
  
  {
    title: "Pillar article on rock climbing",
    stars: 5,
    text: "Tried many freelancers to help me write blog articles but Jovan was the only one that provided quality work. Will work with again!"
  },
  
  {
    title: "Need more articles for our casual dating blog",
    stars: 5,
    text: "Jovan is always the best choice for original and wonderful content, have worked together a few times and can't be more happy with the pages he delivered to me. Highly recommend!"
  },
  
  {
    title: "7 short articles needed",
    stars: 5,
    text: "Great experience with Jovan and his team! Articles were well-written, addressed all the right points, and always on time (often well ahead of schedule). Would  definitely work with them again and would absolutely recommend to anyone looking for quality content writing ."
  },
  
  {
    title: "ONLINE MARKETING WRITER NEEDED: Excellent Content Creator with Research Skills",
    stars: 5,
    text: "Discussions were detailed and laid out clearly up front, and work was completed quickly and without issues."
  },
  
  {
    title: "Blog Writing",
    stars: 5,
    text: "Really pleased with the work Jovan and his team have done for us. He has exceeded expectations in many ways. The work has been submitted ahead of schedule, and the writing requires less editing on part than most other contractors we've worked with. Would recommend Jovan to anyone looking for quality work done on time and on target!"
  },
  
  {
    title: "I need a Content Writer (LinkedIn Articles) for a Long-term Collaboration",
    stars: 5,
    text: "Jovan has produced truly good quality content, attentive, detail-oriented and great communicator, Jovan earns my highest recommendation."
  },
  
  {
    title: "A.Paper",
    stars: 5,
    text: "Yet another successfully completed project with Jovan. Top notch quality and extremely responsive to our needs. A true pro, strongly recommended."
  },
  
  {
    title: "New Software re-writes x 20 (List 18112018)",
    stars: 5,
    text: "Jovan is a pleasure to work with. He is always on time with the work and understands the scope of the work required."
  },
  
  {
    title: "2 articles for EE",
    stars: 5,
    text: "Their quality of work has been consistently top notch!! Jovan is a great guy and he is extremely responsive to our needs! A true professional."
  },
  
  {
    title: "20 More Articles for Adult Porject",
    stars: 5,
    text: "If you're looking for high quality, unique and SEO-friendly content at affordable prices, Jovan definitely could help! I have received 30 original articles from him  and some of them drive thousands of visitors to my website everyday, that's really amazing! Can't recommend Jovan for writing deep articles any more!"
  },
  
  {
    title: "NH.COM",
    stars: 5,
    text: "Their quality of work has been consistently top notch!! Jovan is a great guy and he is extremely responsive to our needs! A true professional. Strongly recommended."
  },
  
  {
    title: "Experienced Writer for Content Marketing",
    stars: 5,
    text: "Jovan is really easy to communicate and work with, he always delivered content before the dateline. Also, he is professional in what he is doing, keep the good work!"
  },
  
  {
    title: "Technology Blog Post Writer",
    stars: 5,
    text: "Great work! One of the better writing agencies I have hired. I will hire again when I need help in the future."
  },
  
  {
    title: "Articles for NH",
    stars: 5,
    text: "Their quality of work has been consistently top notch, and they have been extremely responsive to our needs and concerns."
  },
  
  {
    title: "Write 5 SEO-focused webpages for a dog related website",
    stars: 5,
    text: "They were extremely professional, responsive to communication and delivered high quality, well-researched work ahead of schedule."
  },
  
  {
    title: "Native English Writers needed for SEO articles",
    stars: 5,
    text: "Very well written and professional content. All deadlines have been met and communication was very open. Would definitely recommend Pavle for any of your projects."
  },
  
  {
    title: "Blogger for Architectural Rendering Platform",
    stars: 5,
    text: "Work is always on time and above expectations. I would highly recommend working with Pavle & Podrom Creative to any of my friends."
  },
  
  {
    title: "Original Biographies for Artist Profile Pages",
    stars: 5,
    text: "Really efficient team and the quality of their work was very good. They were also very flexible when last-minute requests would come up or if deadlines needed to be  pushed up. Definitely plan on hiring again!"
  },
  
  {
    title: "Reliable article writers needed for an ongoing tech related project",
    stars: 5,
    text: "Great quality of work, excellent communication, very flexible to work on updates if asked. It was a pleasure to work with you."
  },
  
  {
    title: "Content Writer & Strategist for a Software Product",
    stars: 5,
    text: "An outstanding service with unparalleled communication, adherence to schedule and top-notch quality of work. Excited to work with Pavle and the Podroom team. Would  definitely recommend working with them, you'd be in good hands!"
  },
  
  {
    title: "Content writer for the auto part online store blog.",
    stars: 5,
    text: "Pavle is a very good content writer. Work with him was a pleasure. Very talented writer. We will definitely work together in the future."
  },
  
  {
    title: "Website Content for a Safe and Filing Cabinet Sales Company",
    stars: 5,
    text: "Wow...simply wow. Can't wait for the next"
  },
  
  {
    title: "Need A Great Blog Writer to Write 4 Blogs for a New Website",
    stars: 5,
    text: "These blogs are fantastic. Their ability to work with a niche subject matter is really impressive."
  },
  
  {
    title: "6 High Quality Blogs Posts",
    stars: 5,
    text: "Continues to amaze time and time again. We are looking forward to the next set of blogs."
  },
  
  {
    title: "Content for multiple locations for electrical business",
    stars: 5,
    text: "Articles were great and delivered on time. Will use again in the future."
  },
  
  {
    title: "Seeking experienced & dynamic creative writers for product descriptions",
    stars: 5,
    text: "Pavle and his team are second to none when it comes to writing content on Upwork. 1st class, A++ freelancers who take on your initial brief and then get all over it to complete the set task within the agreed deadlines."
  },
  
  {
    title: "6 High Quality Blogs Posts",
    stars: 5,
    text: "The blogs that they are producing continue to be well thought out and professionally written. We will continue to use them again and again!"
  },
  
  {
    title: "Text writing PRO needed | English native speaker",
    stars: 4,
    text: "Amazing service! Pavle and his team prepared a several series of texts and we're very happy with the result. The team communicates brilliantly and delivers as promised. Every time some clarification or changes necessary, it's made on time with precision. Will hire again."
  },
  
  {
    title: "6 High Quality Blogs Posts",
    stars: 5,
    text: "Again and Again, the blogs they produce are fantastic! I would never think of using another company to write our blogs!"
  },
  
  {
    title: "2 High Quality Blogs Posts",
    stars: 5,
    text: "Blogs continue to amaze again and again! Thank you very much for the great work, great quality and attention to our customer requests."
  },
  
  {
    title: "Freelance writer needed for travel, music and festival related articles",
    stars: 4,
    text: "It was a pleasure working with Pavle, always meeting deadlines and great with communication!"
  },
  
  {
    title: "Experienced Crypto PR Article Writer Required",
    stars: 5,
    text: "Pavle handled every step of the contract with integrity and fantastic professionalism. He was a pleasure to work with and communicated frequently throughout the process. I highly recommend him and would definitely use his writing services again in the future. Can’t say enough about how enjoyable it was working with him."
  },
  
  {
    title: "Looking for a writer who can write content and video scripts related to Medical Cannabis.",
    stars: 5,
    text: "Exceptional Service provided by Pavle. Got quality and creativity rich content from pavle. Have no words for him. Definetely going to work with him again."
  },
  
  {
    title: "Fill in website + Slogan.",
    stars: 5,
    text: "Excellent dude. He is very responsive, quick, and talented. I would 100% hire again."
  },
  
  {
    title: "Privacy VS Terms",
    stars: 5,
    text: "Always a pleasure to work with these guys. They deliver quality work in a timely manner and always make sure their clients are happy with it."
  },
  
  {
    title: "Looking for freelancer for blog writing with experience with Video industry (ads, vod, mobile apps)",
    stars: 5,
    text: "Pavle and his team are great - they take time to build quality articles. I would totally recommend them for the quality of job and speed of delivery"
  },
  
  {
    title: "Article Writing",
    stars: 5,
    text: "Pavle has been an absolute pleasure to work with and the quality of the work is outstanding. We definitely look forward to future projects with him and would highly recommend him and his team. Always on time and always communicative."
  },
  
  {
    title: "3 articles needed",
    stars: 5,
    text: "I don't have anything but good words about Pavle and his work. All of my projects were completed in a timely manner, with great quality, and he's been great at communicating throughout. Thanks!"
  },
  
  {
    title: "Blog Writing for B2B enterprise software for HR",
    stars: 5,
    text: "Amazing quality of blogs. Timely communication. Rehiring again with no questions asked. Excellent work!"
  },
  
  {
    title: "SEO Article Writing",
    stars: 5,
    text: "Great communication and solid work as well. Always a pleasure, looking forward to working on our next project together."
  },
  
  {
    title: "Need Ghost Writer",
    stars: 5,
    text: "Thank you so much for the great work. Highly recommended freelancer. Hope to work with you again. Strict deadlines, high quality work."
  },
  
  {
    title: "Blog Article Writing",
    stars: 5,
    text: "Pavle has been producing great work for us and has been polite and engaging. We look forward to future writing projects with him."
  },
  
  {
    title: "Blog Article Writing",
    stars: 5,
    text: "It is always a pleasure working with Pavle and his team. We will certainly be working with him in the near future."
  },
  
  {
    title: "Need Articles and Blogs Written",
    stars: 5,
    text: "It has been a pleasure to work with Pavle and I certainly look forward to working with him again in the future. Great communications skills and on-time with delivery"
  }
]